/**
 * @generated SignedSource<<5e35cda50cc1f383ae215cb68baca92f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ShortcutsUpdateInput = {
  shortcuts: ReadonlyArray<ShortcutInput>;
};
export type ShortcutInput = {
  label: string;
  text: string;
};
export type ShortcutUpdateReloadDialog_shortcutUpdateMutation$variables = {
  input: ShortcutsUpdateInput;
};
export type ShortcutUpdateReloadDialog_shortcutUpdateMutation$data = {
  readonly shortcutsUpdate: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
    readonly text: string;
  }>;
};
export type ShortcutUpdateReloadDialog_shortcutUpdateMutation = {
  response: ShortcutUpdateReloadDialog_shortcutUpdateMutation$data;
  variables: ShortcutUpdateReloadDialog_shortcutUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Shortcut",
    "kind": "LinkedField",
    "name": "shortcutsUpdate",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShortcutUpdateReloadDialog_shortcutUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShortcutUpdateReloadDialog_shortcutUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5f74ee803e2bf467e15fc170819e2e9",
    "id": null,
    "metadata": {},
    "name": "ShortcutUpdateReloadDialog_shortcutUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ShortcutUpdateReloadDialog_shortcutUpdateMutation(\n  $input: ShortcutsUpdateInput!\n) {\n  shortcutsUpdate(input: $input) {\n    id\n    label\n    text\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a0b9c5a46fc0f8493f5885c7e4ac6f3";

export default node;
